import { GraphQLClient } from 'graphql-request'

import { getSdk } from '@/types/cate-graphql-generated-types'
import { generateUuidRequestId } from '@/utils/uuid-request-id'

function createCateGraphQLClient(endpoint: string) {
  const client = new GraphQLClient(endpoint, {
    headers: {
      'X-Request-ID': generateUuidRequestId(),
    },
  })
  return getSdk(client)
}

const cateGraphQLClient = createCateGraphQLClient(process.env.NEXT_PUBLIC_CATE_GRAPHQL_ENDPOINT)

export default cateGraphQLClient
